<template>
  <div class="text-container" style="margin-block: 8px;">
    <!-- <div>
      {{ text }}
    </div> -->
    <div v-if="showFullText">
      {{ fullText }}
      <i
        style="color: #337ab7; cursor: pointer; font-style: inherit"
        @click="showFullText = false"
        >Show Less</i
      >
    </div>
    <div v-else>
      {{ shortText }}
      <i
        v-if="shouldShowBtn"
        style="color: #337ab7; cursor: pointer; font-style: inherit"
        @click="showFullText = true"
        >Show More</i
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFullText: false,
      shouldShowBtn: true,
    }
  },
  computed: {
    fullText() {
      return this.text
    },
    shortText() {
      if (this.text?.length < 360) {
        this.shouldShowBtn = false
        return this.text
      }
      return this.text.slice(0, 360) + '...'
    },
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>
